import React from 'react';
import ChatbotCard from './ChatbotCard';
import { Plus } from 'lucide-react';

function ChatbotList({ chatbots, onDelete, onEditChatbot, viewMode = 'grid', onCreate }) {

  // Empty State - Guided
  if (!chatbots.length) {
    return (
      <div className="flex flex-col items-center justify-center p-12 text-center border-2 border-dashed border-slate-200 rounded-3xl bg-slate-50/50">
        <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center shadow-lg shadow-violet-500/5 mb-6">
          <Plus size={32} className="text-violet-500" />
        </div>
        <h3 className="text-xl font-bold text-slate-800 mb-2">No chatbots yet</h3>
        <p className="text-slate-500 max-w-sm mb-8">Create your first AI assistant to start engaging with your visitors automatically.</p>
        <button
          onClick={onCreate}
          className="bg-violet-600 hover:bg-violet-700 text-white px-6 py-3 rounded-xl font-bold transition-all shadow-lg shadow-violet-600/20"
        >
          Create Your First Chatbot
        </button>
      </div>
    );
  }

  // Grid View
  if (viewMode === 'grid') {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-12">
        {/* Create New Card - Always first */}
        <button
          onClick={onCreate}
          className="group flex flex-col items-center justify-center h-full min-h-[200px] border-2 border-dashed border-slate-200 hover:border-violet-300 rounded-2xl bg-slate-50/30 hover:bg-violet-50/30 transition-all duration-300"
        >
          <div className="w-14 h-14 rounded-full bg-white shadow-sm flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 text-slate-400 group-hover:text-violet-500">
            <Plus size={28} />
          </div>
          <span className="font-bold text-slate-500 group-hover:text-violet-600 transition-colors">Create New Chatbot</span>
        </button>

        {chatbots.map((chatbot) => (
          <ChatbotCard
            key={chatbot.chatbot_id}
            chatbot={chatbot}
            onDelete={onDelete}
            onEditChatbot={onEditChatbot}
          />
        ))}
      </div>
    );
  }

  // List View (Simple for now)
  return (
    <div className="flex flex-col gap-3 pb-12">
      <button
        onClick={onCreate}
        className="flex items-center gap-3 p-4 border border-dashed border-slate-300 rounded-xl hover:bg-slate-50 text-slate-500 hover:text-violet-600 font-medium transition-colors"
      >
        <Plus size={20} />
        <span>Create New Chatbot</span>
      </button>
      {chatbots.map((chatbot) => (
        <div key={chatbot.chatbot_id} className="flex items-center justify-between p-4 bg-white border border-slate-100 rounded-xl shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg bg-violet-100 text-violet-600 flex items-center justify-center font-bold">
              {chatbot.config.assistantName?.[0] || 'C'}
            </div>
            <div>
              <h3 className="font-bold text-slate-800">{chatbot.config.assistantName}</h3>
              <p className="text-xs text-slate-400">ID: {chatbot.chatbot_id}</p>
            </div>
          </div>
          <div className="flex gap-2">
            <button onClick={() => onEditChatbot(chatbot.chatbot_id)} className="px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 rounded-lg border border-slate-200">Edit</button>
            <button className="px-4 py-2 text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 rounded-lg shadow-sm">Inbox</button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChatbotList;
